//import '../../node_modules/@fortawesome/fontawesome-free/css/all.css';

import "../styles/app.scss";
import 'bootstrap';
require('bootstrap');


// Perso
import $ from "jquery"
//import {AjaxForms} from './inc/ajaxforms.js';
//import {LoadMore} from './inc/loadmore.js';
//import {AnimateScroll} from './inc/AnimateScroll/animate-scroll.js';

class App{    

    constructor(){

        // Menu hamburger
        this.hamburger = $('#hamburger')
        this.menu = $( '#top-nav' )    
        this.menuRs = $( '#menu-right ul' )

        // Ecouteurs
        this.hamburger.on( 'click' , e => {
            this.clickHamburger()
        })

        // Loadmore
        //new LoadMore( '#loadmore-container' , '#loadmore-btn' )

        // Formulaires en Ajax
        //new AjaxForms()   

        // Animation au Scroll
        //new AnimateScroll()

    }

    clickHamburger(){
        this.hamburger.toggleClass('active')
        this.menu.toggleClass('active')
        this.menuRs.toggleClass('active')
    }    

}

new App()

